import { render, staticRenderFns } from "./EventiOperatoriComponent.vue?vue&type=template&id=4c6a8383"
import script from "./EventiOperatoriComponent.vue?vue&type=script&lang=js"
export * from "./EventiOperatoriComponent.vue?vue&type=script&lang=js"
import style0 from "./EventiOperatoriComponent.vue?vue&type=style&index=0&id=4c6a8383&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports